import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../../colorVars';
import CloseWindowButton from '../../../../../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { MultiSwitch } from '../../../../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { BoxInput } from '../../../../../../../../../atomic/inputs/boxInput/BoxInput';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../../../alertFormClass';
import style from './PriceIntersectsFirstCandleModule.module.css';

export const PriceIntersectsFirstCandleModule = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <div></div>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Price Inter. 1st Candle
        </Body3>
        <CloseWindowButton
          margin="0 0 7px 5px"
          width={10}
          stroke={2}
          color={colors.red}
          handleClick={() =>
            form.removeSetupFilter('PRICE_INTERSECTS_FIRST_CANDLE')
          }
        />
      </header>
      <div className={style.body}>
        <div className={style.inputAndLabel}>
          <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
            Duration:
          </Body3>
          <BoxInput
            value={
              form.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE'].candleDuration
            }
            setValue={(value) =>
              form.updateSetupFilterField(
                'PRICE_INTERSECTS_FIRST_CANDLE',
                'candleDuration',
                value
              )
            }
            fontSize={fontSizes.body3}
            backgroundColor={colors.black}
            width="60px"
            symbol="min"
            direction="right"
          />
        </div>
        <div className={style.inputAndLabel}>
          <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
            Direction:
          </Body3>
          <MultiSwitch
            labels={['Below', 'Above']}
            values={['BELOW', 'ABOVE']}
            controlledValue={
              form.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE'].direction
            }
            setValue={(value) =>
              form.updateSetupFilterField(
                'PRICE_INTERSECTS_FIRST_CANDLE',
                'direction',
                value
              )
            }
          />
        </div>
        <div className={style.inputAndLabelLast}>
          <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
            Barrier:
          </Body3>
          <MultiSwitch
            labels={['Low', 'High']}
            values={['LOW', 'HIGH']}
            controlledValue={
              form.setupFilters['PRICE_INTERSECTS_FIRST_CANDLE'].candleBarrier
            }
            setValue={(value) =>
              form.updateSetupFilterField(
                'PRICE_INTERSECTS_FIRST_CANDLE',
                'candleBarrier',
                value
              )
            }
          />
        </div>
      </div>
    </div>
  );
});
